import { BarSeriesType, LineSeriesType } from "@mui/x-charts";
import { Dispatch } from "../../controller";
import { CanalDistribuicao, DespesaCanalDistribuicao, EstoqueCanalDistriuicao, Item, Movimentacao } from "../../data.types";
import { Model,StateProps } from "../../model";
import { listDataText } from "../../services/utils";
import { Funcionario } from "../funcionario/funcionario.model";

export type { CanalDistribuicao } from "../../data.types";

const listDataOpt = listDataText();

export interface ResumoMpMovimentacoesByCanalDistProps{
    descricaoMp:string;
    totalMp:number;
}

export type DemonstrativoType = "anual"|"mensal"|"diario";

export interface FiltroReadMovCanal {
    canal_id:string,
    dtIni?:string,
    dtFim?:string,  
    periodo?:DemonstrativoType
}

export interface EstoqueDistCalc{
    id_item:string,
    desc_item:string,
    qt_entrada:number,
    qt_saida:number,
    saldo:number
}

export interface TotalFaturadoProps{
    id:any,
    total:number,
    data:string
}

export interface ChartBarSeries extends BarSeriesType{
    axisId:any
}

export interface CanalDistribuicaoState extends StateProps<CanalDistribuicao> {
    tabValue:number  
    rowsMovCanal:Movimentacao[]
    resumoMovsMp:ResumoMpMovimentacoesByCanalDistProps[]
    filtroMovCanal:FiltroReadMovCanal
    estoqueCanal:EstoqueDistCalc[]
    loadCharBar:boolean
    chartBarSeries:ChartBarSeries[]
    chartBarDataAxis:string[]
    loadChartLine:boolean
    chartLineSeries:LineSeriesType[]
    chartLineDataAxis:string[]
    rowsTotalFatPeriodo:TotalFaturadoProps[]
    showModalEditarCanalDist:boolean
    canalAberto:CanalDistribuicao
    showModalEstoque:boolean
    valueEstoque:EstoqueCanalDistriuicao
    showModalDespesa:boolean 
    valueDespesa:DespesaCanalDistribuicao
    rowsSelected:CanalDistribuicao[]
}

export interface CanalDistribuicaoActions extends Dispatch<CanalDistribuicao> {
    setTabValue:(value:number)=>any
    setSituacao:(situacao:"PENDENTE" | "ABERTO" | "FECHADO")=>any
    readMovsCanal:(filtro:FiltroReadMovCanal)=>any
    getResumoMpMovByCanalDist:()=>any
    readCanalDistAbertos:()=>any
    calcSaldoEstoqueCanal:()=>any
    getResumoMpGroupByData:(filtro:FiltroReadMovCanal)=>any
    setFiltro:(filtro:FiltroReadMovCanal)=>any
    readCanalDistByPeriodo:(filtro:FiltroReadMovCanal)=>any
    getTotalFaturadoByPeriodo:(filtro:FiltroReadMovCanal)=>any
    readCanalDistByData:(filtro:FiltroReadMovCanal)=>any
    getCanalDistByFuncionario: (funcionario: Funcionario) => any;
    addCanalDist: (funcionario: Funcionario) => any;    
    abrirCanalDist:(showCad:boolean)=>any
    setShowModalEditarCanalDist:(show:boolean)=>any
    getCanalDistAberto:()=>any
    readCanalDistByDia:(data:string)=>any
}

const model = new Model<CanalDistribuicao,CanalDistribuicaoState>("canaldist");

export const intialValueCanalDistribuicao:CanalDistribuicao = {
    ...model.getInitialValue(),
    type:"canaldist",
    situacao:"PENDENTE",
    data:"",
    funcionario: {nome:""} as Funcionario,//nessessário campo label para o autocomplete do funcionario
    fechamento:{
        resumo_mp:[],
        total:0
    },
    estoque_dist:[],
    despesas:[],
}

export const initialValueState:CanalDistribuicaoState = {
    ...model.getInititalValueState(),
    row:intialValueCanalDistribuicao,
    tabValue:0,
    resumoMovsMp:[],
    rowsMovCanal:[],
    filtroMovCanal:{
        canal_id:"",
        dtIni:listDataOpt[3].value.dtIni,
        dtFim:listDataOpt[3].value.dtFim,
        periodo:"diario"
    },
    estoqueCanal:[],
    loadCharBar:false,
    chartBarSeries:[],
    chartBarDataAxis:[],
    loadChartLine:false,
    chartLineSeries:[],
    chartLineDataAxis:[],
    rowsTotalFatPeriodo:[],
    canalAberto:{} as CanalDistribuicao,
    showModalEditarCanalDist:false,
    showModalEstoque:false,
    showModalDespesa:false,
    valueDespesa: { _id: "", descricao: "", valor: 0 },
    valueEstoque:{ _id: "", item: {} as Item, qt: 0 },
    rowsSelected:[]

}


